import React from "react";
import "./Button.css";

/**
 * Props:
 * - variant: "primary" | "secondary" | "ghost" (default: "primary")
 * - size: "md" | "sm" (default: "md")
 * - fullWidth?: boolean
 * - startIcon?: ReactNode
 * - endIcon?: ReactNode
 * - disabled?: boolean
 * - type?: "button" | "submit" | "reset"
 * - onClick?: () => void
 * - className?: string (classes extras opcionais)
 */
export default function Button({
  children,
  variant = "primary",
  size = "md",
  fullWidth = false,
  startIcon,
  endIcon,
  disabled = false,
  type = "button",
  onClick,
  className = "",
  ...rest
}) {
  const classes = [
    "btn",
    `btn--${variant}`,
    `btn--${size}`,
    fullWidth ? "btn--block" : "",
    disabled ? "btn--disabled" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {startIcon && <span className="btn__icon btn__icon--start">{startIcon}</span>}
      <span className="btn__label">{children}</span>
      {endIcon && <span className="btn__icon btn__icon--end">{endIcon}</span>}
    </button>
  );
}
